import React, { useEffect, useState } from "react";
import { getPartners } from "../../Transformations/NewsList";
import "./kooperationspartner.css";
import FLoader from "../../Transformations/FLoader";

export default function Kooperationspartner() {
	const [propertyP, setPropertyP] = useState([]);
	const [esgP, setEsgP] = useState([]);
	const [partners, setPartners] = useState(false);
	useEffect(() => {
		const fetchData = async () => {
			const data = await getPartners();
			setPartners(true);
			setEsgP(data.filter((partner) => partner.type === "esg"));
			setPropertyP(data.filter((partner) => partner.type !== "esg"));
		};
		fetchData();
	}, []);

	return (
		<div className="partners-page">
			<div className="row partners-section">
				<div className="col-md-12">
					<h1 className="py-2">Kooperationspartner</h1>
				</div>

				{partners ? (
					<div className="row d-flex">
						<div className="col-md-12 row ">
							<hr></hr>
							<h2 className="pb-5">Immobilienverwaltungsbranche</h2>

							{propertyP.map((p) => (
								<div key={p.id} className="col-md-6 px-0 pb-5 text-center">
									<img
										className="partner-logo"
										title={p.name}
										alt="Logo"
										src={p.logo}
									/>
								</div>
							))}
						</div>
						<div className="col-md-12  row py-5">
							<hr></hr>
							<h2 className="pb-5">ESG</h2>
							<ul className="partner-list">
								{esgP.map((p) => (
									<li key={p.id}>
										<img
											className="partner-logo"
											title={p.name}
											alt="Logo"
											src={p.logo}
										/>
									</li>
								))}
							</ul>
						</div>
					</div>
				) : (
					<FLoader />
				)}
			</div>
			<div className="kontakt-btn">
				<aside className="contact-sec beratun_kontakt">
					<p>
						Setzen Sie sich mit uns in Verbindung und lassen Sie sich
						unverbindlich beraten.
					</p>
					<a className="link-button" href="/kontakt">
						Kontaktieren Sie uns
					</a>
				</aside>
			</div>
		</div>
	);
}
